namespace ui
{
	export namespace pattern
	{
		export namespace observer
		{
			export abstract class Subject
			{
				private SubjectList: Observer[];
				private counter: number;

				constructor()
				{
					this.SubjectList = [];
					this.counter = 0;
				}

				public notify( data?: any )
				{
					for ( const i in this.SubjectList )
					{
						this.SubjectList[ i ].update( data );
					}
				}

				protected register( subject: Observer)
				{
					this.SubjectList.push( subject );

					subject.setIndex( ++this.counter );
				}

				protected unregister( subject: Observer ) : boolean
				{
					for ( let i = 0; i < this.SubjectList.length; ++i )
					{
						if ( this.SubjectList[ i ].getIndex() == subject.getIndex() )
						{
							this.SubjectList.splice( i, 1 );

							--i;
						}
					}

					return true;
				}
			}

			export abstract class Observer
			{
				private idx: number;

				constructor()
				{
					this.idx = -1;
				}

				public setIndex( index: number ) : void
				{
					this.idx = index;
				}

				public getIndex() : number
				{
					return this.idx;
				}

				public abstract update( data?: any ) : void;
			}
		}
	}
}
